import AppSignal from "@appsignal/javascript";
import { plugin as consoleBreadcrumbsPlugin } from "@appsignal/plugin-breadcrumbs-console";
import { plugin as pathDecoratorPlugin } from "@appsignal/plugin-path-decorator";
import { plugin as windowEventsPlugin } from "@appsignal/plugin-window-events";

export const appSignal = new AppSignal({
  key: import.meta.env.VITE_APPSIGNAL_KEY,
  namespace: import.meta.env.VITE_APPSIGNAL_NAMESPACE,
  revision: import.meta.env.VITE_APPSIGNAL_REVISION,
});

appSignal.use(consoleBreadcrumbsPlugin());
appSignal.use(pathDecoratorPlugin());
appSignal.use(windowEventsPlugin());
